/**
 * // Usage:
 * ```typescript
 * @Component({
 * ...
 * })
 * export class YourComponent extends BaseComponent {
 *   constructor(
 *     loggerService: LoggerService,
 *   ) {
 *     super(loggerService)
 *   }
 *   // Your component code
 *   ngOnInit() {
 *     this.logger.debug('init',arg1,arg2)
 *   }
 * }
 * ```
 */

import {DATE_FORMATS} from "../../../../common/constants/src/lib/date-formats"
import {DETAIL_GROUPS} from "../../../../common/constants/src/lib/details"
import {ADMIN, DRIVER} from "../../../../common/constants/src/lib/table-sizes"
import {DECISIONS} from "../../../../common/constants/src/lib/decisions"
import {AppLogger, LoggerService} from "../../../../services/src/lib/logger.service"
import {Directive} from "@angular/core"


@Directive()
export abstract class BaseComponent {
  protected readonly DATE_FORMATS = DATE_FORMATS
  protected readonly DETAIL_GROUPS = DETAIL_GROUPS
  protected readonly ADMIN = ADMIN
  protected readonly DRIVER = DRIVER
  protected readonly ACTIVE = DECISIONS.ACTIVE
  protected readonly INACTIVE = DECISIONS.INACTIVE
  protected readonly VALID = DECISIONS.VALID
  protected readonly INVALID = DECISIONS.INVALID
  protected readonly logger: AppLogger


  constructor(protected readonly loggerService: LoggerService) {
    const context = this.constructor.name
    this.logger = this.loggerService.create(context)
  }
}


